import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { mcpAccountsUrl, resolveMcpAuth } from './mcp-auth';
import { submitLogToBugsnag } from '../log';

export default async function refresh_mcp_accounts_api_call(
  connectionId: number
) {
  try {
    const auth = resolveMcpAuth();

    const requestInfo: RequestInfo = {
      url: mcpAccountsUrl(auth, connectionId),
      method: 'POST',
      body: '',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        Authorization: auth.authorization,
      },
    };

    const actionType = 'REFRESH_MCP_ACCOUNTS';
    const customMsg = 'Accounts refreshed successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false
    );

    const response = res?.data;
    if (!response.success) {
      return false;
    }
    if (res.actionType === actionType && response.success === true) {
      return response?.data;
    }
  } catch (exception) {
    console.log('Error refreshing MCP accounts');
    submitLogToBugsnag('error', `Error refreshing MCP accounts: ${exception}`);
    return false;
  }
}
